import { buildPickSheetHtml } from '@/lib/pickSheetHtml'
import type { PickList } from '@/types/pickList'

/**
 * Print a pick sheet through a hidden iframe.
 *
 * The iframe (rather than `window.open`) is deliberate: a popup is blocked by
 * default in most browsers and the failure is silent, which for a sheet someone
 * is standing at a printer waiting for is the worst possible outcome. Mirrors
 * the DIN-label print on PatientProcedurePage.
 *
 * All the document building lives in `buildPickSheetHtml`, which is pure and
 * unit tested; this function is only the browser plumbing.
 */
export function printPickSheet(pickList: PickList): void {
  const iframe = document.createElement('iframe')
  iframe.setAttribute('aria-hidden', 'true')
  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0'
  document.body.appendChild(iframe)

  const doc = iframe.contentWindow?.document
  if (!doc) {
    iframe.remove()
    return
  }
  doc.open()
  doc.write(buildPickSheetHtml(pickList))
  doc.close()

  const win = iframe.contentWindow
  if (!win) {
    iframe.remove()
    return
  }
  // Remove the iframe once the print dialog is dismissed.
  win.onafterprint = () => iframe.remove()
  win.focus()
  win.print()
}
